module.exports = __webpack_public_path__ + "img/HLTW-cover.4550a39b.jpg";